import type { PreloadDisplayStatusKind } from "./preloadStatus"

export const STATUS_PALETTE = {
	success: {
		border: "#4CAF50",
		color: "#4CAF50",
		background: "rgba(76, 175, 80, 0.15)",
	},
	info: {
		border: "#2196F3",
		color: "#2196F3",
		background: "rgba(33, 150, 243, 0.15)",
	},
	warning: {
		border: "#FF9800",
		color: "#FF9800",
		background: "rgba(255, 152, 0, 0.15)",
	},
	danger: {
		border: "#F44336",
		color: "#F44336",
		background: "rgba(244, 67, 54, 0.15)",
	},
	neutral: {
		border: "var(--color-border-default)",
		color: "var(--text-secondary-color)",
		background: "var(--color-hover-neutral)",
	},
} as const

export type StatusPaletteName = keyof typeof STATUS_PALETTE

export const getStatusPalette = (name: StatusPaletteName) => STATUS_PALETTE[name]

export const PRELOAD_STATUS_PALETTE_NAMES: Record<PreloadDisplayStatusKind, StatusPaletteName> = {
	loaded: "success",
	failed: "danger",
	cancelled: "neutral",
	unloading: "warning",
	not_loaded: "neutral",
	queued: "info",
	loading: "info",
}

export const getPreloadStatusPaletteName = (
	kind: PreloadDisplayStatusKind
): StatusPaletteName => PRELOAD_STATUS_PALETTE_NAMES[kind]
